import { HomeJournalEdit } from "@/components/journal/HomeJournalEdit";
import { PublicNav } from "./PublicNav";
import { Footer } from "./Footer";
import { ImmersiveHome } from "./ImmersiveHome";
import { HomeExplore } from "./HomeExplore";
import { HomeQuoteStarter } from "./HomeQuoteStarter";

export function PublicHomeGateway() {
  return <div className="bws-home gg-home gg-compact-home"><PublicNav /><main><ImmersiveHome /><HomeQuoteStarter /><HomeJournalEdit /><HomeExplore /></main><Footer /></div>;
}
